import { IOrderLineTotals } from "./order-line-totals";

export interface IOrderLine {
  version?: number,
  isDeactivated?: boolean,
  fiscalSetupId?: number,
  createdAt?: Date,
  locationId?: number,
  orderInvoiceTaskId?: number,
  orderTaskId?: number,
  orderId?: number,
  projectId?: number,
  index?: number,
  articleId?: number,
  invoiceDateDays?: number,
  costEach?: number,
  description?: string,
  priceEach?: number,
  quantity?: number,
  unitId?: number,
  payerId?: number,
  payerAccountNumber?: number,
  unitAbbreviation?: string,
  articleNumber?: string,
  totals?: IOrderLineTotals,
  articleGroupId?: number,
  articleVariantId?: number,
  articleGroupDescription?: string,
  articleHasInventoryManagement?: boolean,
  articleHasVariants?: boolean,
  articleInternalNote?: string,
  articleIsBundle?: boolean,
  articleVariantAbbreviation?: string,
  articleWeight?: number,
  locationAbbreviation?: string,
  articleStatus?: string,
  orderDeliveryTransactionId?: number,
  articleMappingId?: number,
  articleMappingQuantity?: number,
  partnerArticleNumber?: string,
  isConfirmed?: boolean,
  articleAbbreviation?: string,
  isDelivered?: boolean,
  articleIsDeactivated?: boolean,
  averageCostPrice?: number,
  estimatedCostTotal?: number,
  orderLineStatusColor?: string,
  orderLineStatusName?: string,
  hasLinkedLines?: boolean,
  id?: number
}
